/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueResource from 'vue-resource'
import VueLanguage from 'vue-multilanguage'
import colors from 'vuetify/es5/util/colors'
import translate from './translate/index'
import momentDurationFormatSetup from 'moment-duration-format'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import VueEditor from 'vue2-editor'
import moment from 'moment'
import { RichTextEditorPlugin } from '@syncfusion/ej2-vue-richtexteditor'
import animate from 'animate.css'
import VueClip from 'vue-clip'
import VueSocketio from 'vue-socket.io'
import io from 'socket.io-client'
import money from 'v-money'
/* Inicio vue-auth */
import auth                  from '@websanova/vue-auth/dist/v2/vue-auth.js';
import driverAuthBearer      from '@websanova/vue-auth/dist/drivers/auth/bearer.js';
import driverHttpResource    from '@websanova/vue-auth/dist/drivers/http/vue-resource.1.x.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js';
// import driverOAuth2Google    from '@websanova/vue-auth/dist/drivers/oauth2/google.js';
// import driverOAuth2Facebook  from '@websanova/vue-auth/dist/drivers/oauth2/facebook.js';

/* Fim vue-auth */


// VueGtm por algum motivo estava atrapalhando os pagamentos parando de funcionar. Portanto foi tirado o VueGtm
import VueGtm from 'vue-gtm'
Vue.use(VueGtm, {
  // id: '    GTM-KVB3T22' // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  id: 'GTM-PNDGG9K', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview:'env-4',
  //   gtm_cookies_win:'x'
  // },
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})

// Merge the locales.
import VeeValidate from "vee-validate";
import pt_BR from "vee-validate/dist/locale/pt_BR";

VeeValidate.Validator.localize({ pt_BR: pt_BR})
// VeeValidate.Validator.addLocale(VeeValidateMessagesBR);
Vue.use(VeeValidate, {locale: 'pt_BR'});
// VeeValidate.Validator.setLocale('pt_BR');
Vue.use(VueClip) // Componente usado para fazer upload de arquivos no chat
Vue.use(new VueSocketio({connection: io(process.env.LIVE)}))
Vue.use(money, {precision: 2})
Vue.prototype.moment = moment
momentDurationFormatSetup(Vue.prototype.moment)

window.$ = window.jQuery = require('jquery')
require('vegas')
require('font-awesome/css/font-awesome.min.css')
require('vue2-dropzone/dist/vue2Dropzone.css')

require('vue-swatches/dist/vue-swatches.min.css')

Vue.router = router
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyAPXbo6cqoqCWq8Lrwnt6zLhfGy68O_eAM'// Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  // version: '...', // Optional
})
Vue.use(VueResource)
Vue.use(VueEditor)
Vue.use(VueLanguage, translate)
Vue.use(animate)
Vue.use(RichTextEditorPlugin)
Vue.use(Vuetify, {
  theme: {
    primary: colors.cyan.darken1, // #E53935
    secondary: colors.green.base, // #FFCDD2
    accent: colors.indigo.base // #3F51B5
  }
})
// Vue.use(require('@websanova/vue-auth'), {
//   refreshData: {enabled: false, interval: 0},
//   auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
//   http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
//   router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
//   rolesVar: 'type'
// })

// driverOAuth2Google.params.client_id = '547886745924-4vrbhl09fr3t771drtupacct6f788566.apps.googleusercontent.com';
// driverOAuth2Facebook.params.client_id = '196729390739201';

Vue.use(auth, {
  plugins: {
      http: Vue.http, // Vue Resource
      router: Vue.router,
  },
  drivers: {
      auth: driverAuthBearer,
      http: driverHttpResource,
      router: driverRouterVueRouter,
      // oauth2: {
      //     google: driverOAuth2Google,
      //     facebook: driverOAuth2Facebook,
      // }
  },
  options: {
      refreshData: {enabled: false, interval: 0},
      rolesKey: 'type',
      notFoundRedirect: {name: 'user-account'},
  }
});
// Quando for gerar o build para o new.illis alterar o new no arquivo prod.env.js
// process.env.API = 'https://new.api.illis.com.br'
Vue.http.options.root = process.env.API
Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatAbbreviation', function (value, size) {
  let abreviated = String(value)
  if (String(value).length > size) {
    abreviated = String(value).substring(0, size).trim() + '...'
  }
  return abreviated
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js